import { Router, NavigationStart } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { filter } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { Story, Company } from './shared/models';
import { Observable } from 'rxjs';

const description =
  'Forbes CAREERは日本の未来を担うスタートアップ、隠れた名企業との出会いの場です。Forbes編集部が発掘した企業・ヒトに潜む、情熱的かつドラマティックなストーリーをお楽しみください。';
const siteUrl = 'https://forbesjapan-career.com/';
const siteName = 'Forbes CAREER (フォーブス キャリア)';
const ogpImage = '/assets/img/ogp.jpg';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  story$: Observable<Story>;
  story: Story;
  company$: Observable<Company>;
  company: Company;

  constructor(
    private auth: AngularFireAuth,
    private meta: Meta,
    private title: Title,
    private router: Router,
    private db: AngularFirestore
  ) {}

  async loadCompany(companyId: string, storyTitle: string) {
    const comRef = this.db.doc(companyId);
    try {
      const company = await comRef.get().toPromise();
      this.title.setTitle(company.get('name') + ' - ' + storyTitle + '｜Forbes CAREER');
      this.meta.updateTag({
        name: 'description',
        content: company.get('name') + 'のストーリーと求人・採用情報を掲載しています。',
      });
    } catch (e) {
      console.log(e);
    }
  }

  async loadStory(storyId: string) {
    const ref = this.db.doc(storyId.replace(/ry/g, 'ries'));
    try {
      const story = await ref.get().toPromise();
      this.loadCompany(story.get('company'), story.get('title'));
    } catch (e) {
      console.log(e);
    }
  }

  async ngOnInit() {
    this.auth.auth.setPersistence('local');
    this.router.events
      .pipe(
        filter((event) => {
          return event instanceof NavigationStart;
        })
      )
      .subscribe((event: NavigationStart) => {
        if (event.url.startsWith('/menu')) {
          this.meta.addTag({ name: 'robots', content: 'noindex' });
        } else {
          let attributeSelector: string = 'name="robots"';
          this.meta.removeTag(attributeSelector);
        }

        if (event.url.startsWith('/story') || event.url.startsWith('/jobs') || event.url.startsWith('/company')) {
          if (
            event.url.startsWith('/story') &&
            !event.url.startsWith('/story/latest') &&
            !event.url.startsWith('/story/popular')
          ) {
            this.loadStory(event.url);
          }
          return;
        }

        this.title.setTitle(siteName);
        this.meta.updateTag({ name: 'description', content: description });
        this.meta.updateTag({ property: 'og:title', content: siteName });
        this.meta.updateTag({ property: 'og:description', content: description });
        this.meta.updateTag({ property: 'og:url', content: `${environment.baseUrl}${event.url}` });
        this.meta.updateTag({ property: 'og:image', content: `${environment.baseUrl}${ogpImage}` });
      });
  }
}
